import '../sass/styles.scss';
window.jQuery = $;
import * as $ from 'jquery';

document.addEventListener('DOMContentLoaded', () => {

	$('.open-search').click(function () {
		$('#search-container').slideToggle(200);
		$('#search-container #search').focus();
	});

	$('.close-search').click(function () {
		$('#search-container').slideUp(200);
	});

	$('.load-more').on('click', function () {
		const button = $(this);
		let paged = button.data('paged');

		$.ajax({
			url: brbrApp.ajaxUrl,
			type: 'GET',
			data: {
				action: 'load_posts',
				paged,
			},
		}).always(function (data) {
			if (data.html) {
				$('.article-list').append(data.html);

				paged++;

				if (data.maxpages <= paged) {
					button.hide();
				} else {
					button.show();
					button.data('page', paged);
				}
			}
		});
	});
});
